import React from "react";
import { SalesforceSectionProps } from "../types/types";
import { Form } from "@components";
import { FORM_LABELS } from "../constants/constants";

export const EnvironmentSection: React.FC<SalesforceSectionProps> = ({
  sectionNumber,
  form,
  onFormValueChange,
  language = "EN",
}) => {
  const LABELS = FORM_LABELS[language];

  return (
    <>
      <Form.Title>{`${sectionNumber} - ${LABELS.ENVIRONMENT.FORM_TITLE}`}</Form.Title>
      <Form.Checkbox
        label="QA"
        name="envQA1"
        onChange={onFormValueChange}
        size={3}
        value={form.values.envQA1}
      />
      <Form.Checkbox
        label="CERT"
        name="envCert1"
        onChange={onFormValueChange}
        size={3}
        value={form.values.envCert1}
      />
      <Form.Checkbox
        label="Production"
        name="envProduction"
        onChange={onFormValueChange}
        size={3}
        value={form.values.envProduction}
      />{" "}
    </>
  );
};
